<template>
  <div class="wrapper">
    <div class="list" v-show="!detail">
      <div class="q-item" v-for="(item, index) in list" :key="index">
        <div @click="openDetail(index, type)" class="item f-row f-justify-between f-align-center">
          <div class="f-row f-align-center">
            <span class="block"></span>
            <span class="txt">{{item.title}}</span>
          </div>
          <span class="arrow-right"></span>
        </div>
      </div>
    </div>
    <div class="detail" v-show="detail" v-if="detail">
      <button class="back-btn" @click="backToList">{{ backText }}</button>
      <div class="title f-row f-align-center"><img src="../../assets/images/q.webp"
                                                   alt="" /><span>{{detail.title}}</span></div>
      <div class="content">
        <div class="content-block" v-for="(item, idx) in detail.content" :key="idx">
          <img
            v-if="isContentImage(item)"
            class="content-image"
            :src="item.src"
            :alt="item.alt || ''"
          />
          <p v-else-if="isContentParagraph(item)">
            <template v-for="(part, partIndex) in item.parts">
              <router-link
                v-if="isContentLink(part)"
                :key="'link-' + partIndex"
                class="content-link"
                :to="articleLinkTo(part)"
              >{{ part.text }}</router-link>
              <span
                v-else-if="isContentComponentLabel(part)"
                :key="'label-' + partIndex"
                class="component-label"
              >{{ part.text }}</span>
              <span v-else :key="'text-' + partIndex">{{contentText(part)}}</span>
            </template>
          </p>
          <p v-else-if="isContentLink(item)">
            <router-link class="content-link" :to="articleLinkTo(item)">{{ item.text }}</router-link>
          </p>
          <a
            v-else-if="isContentExternalLink(item)"
            class="content-external-link"
            :href="item.url"
            target="_blank"
            rel="noopener"
          >{{ item.text }}</a>
          <a
            v-else-if="isContentDownload(item)"
            class="download-link"
            :href="item.url"
            target="_blank"
            rel="noopener"
          >{{ item.text }}</a>
          <p v-else>{{contentText(item)}}</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { cate, getFaqArticlesForLang, getFaqMetaForLang, resolveArticleByTag, supportedFaqLang } from './data'
export default {
  name: 'helpCat',
  components: {},
  props: {},
  data () {
    return {
      type: '',
      list: [],
      detail: null,
      lang: 'en'
    }
  },
  computed: {
    backText () {
      return getFaqMetaForLang(this.lang).backToList
    }
  },
  watch: {},
  created () {
    this.lang = supportedFaqLang(this.$route.query.lang)
    const tag = this.$route.params.tag
    if (tag) {
      this.type = 'hot'
      this.list = getFaqArticlesForLang(this.lang)
      this.detail = resolveArticleByTag(tag, this.lang)
      document.title = 'FAQ'
      return
    }

    const id = this.$route.params.id
    const type = this.$route.params.type

    this.type = type
    if (type === 'hot') {
      this.list = getFaqArticlesForLang(this.lang)
      document.title = 'FAQ'
    } else {
      for (let key in cate) {
        let item = cate[key]
        if (item.type === type) {
          this.list = item.list
          document.title = item.title
          break
        }
      }
    }
    if (id) {
      this.isDetail = true
      this.detail = this.list[id]
    }
  },
  mounted () { },
  methods: {
    openDetail (id, type) {
      const item = this.list[id]
      if (type === 'hot' && item && item.tag) {
        this.$router.push({
          name: 'ArticleTagContent',
          params: { tag: item.tag },
          query: { lang: this.lang }
        })
        return
      }
      this.$router.push({ path: '/content/' + id + '/' + type, query: { lang: this.lang } })
    },
    backToList () {
      this.$router.push({ path: '/article', query: { lang: this.lang } })
    },
    isContentImage (item) {
      return item && typeof item === 'object' && item.type === 'image' && item.src
    },
    isContentParagraph (item) {
      return item && typeof item === 'object' && item.type === 'paragraph' && Array.isArray(item.parts)
    },
    isContentLink (item) {
      return item && typeof item === 'object' && item.type === 'link' && item.tag
    },
    isContentExternalLink (item) {
      return item && typeof item === 'object' && item.type === 'external-link' && item.url
    },
    isContentDownload (item) {
      return item && typeof item === 'object' && item.type === 'download' && item.url
    },
    isContentComponentLabel (item) {
      return item && typeof item === 'object' && item.type === 'component-label'
    },
    articleLinkTo (item) {
      return {
        name: 'ArticleTagContent',
        params: { tag: item.tag },
        query: { lang: this.lang }
      }
    },
    contentText (item) {
      return typeof item === 'string' ? item : item.text || ''
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: 0;
  padding: 45px 40px;
  background: #fff;
  color: #000;
  .list {
    background-color: #fff;
    padding: 45px 30px;
    border-radius: 0;
    border: 1px solid #fff;
    .item {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 12px;
      column-gap: 24px;
      justify-content: normal;
      min-height: 92px;
      padding: 0 0 34px;
      align-items: flex-start;
      &:last-child {
        padding-bottom: 0;
      }
      > .f-row {
        display: grid;
        grid-template-columns: 23px minmax(0, 1fr);
        column-gap: 26px;
        min-width: 0;
        width: auto;
        align-items: flex-start;
      }
      .block {
        width: 23px;
        height: 23px;
        background: linear-gradient(270deg, #ababab 0%, #f7f7f7 100%);
        border-radius: 100%;
        margin: 19px 0 0;
      }
      .txt {
        display: block;
        min-width: 0;
        max-width: 100%;
        font-size: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 60px;
        color: #0000ee;
        cursor: pointer;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: normal;
      }
      .arrow-right {
        border-top: 2px solid #ababab;
        border-right: 2px solid #ababab;
        width: 12px;
        height: 12px;
        margin-top: 22px;
        transform: rotate(45deg);
      }
    }
  }
  .detail {
    background-color: #fff;
    padding: 45px 30px;
    border-radius: 0;
    border: 1px solid #fff;

    font-family: PingFangSC-Semibold, PingFang SC;
    color: #000;
    .back-btn {
      margin-bottom: 40px;
      padding: 18px 28px;
      border: 1px solid #000;
      border-radius: 12px;
      background: #fff;
      color: #000;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .title {
      display: grid;
      grid-template-columns: 60px minmax(0, 1fr);
      column-gap: 25px;
      align-items: flex-start;
      img {
        width: 60px;
        height: 60px;
        margin: 6px 0 0;
      }
      span {
        display: block;
        min-width: 0;
        max-width: 100%;
        font-size: 45px;
        font-weight: 600;
        line-height: 62px;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: normal;
      }
    }
    .content {
      margin-top: 50px;
      font-size: 40px;
      font-weight: 400;
      line-height: 70px;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: normal;
      .content-block + .content-block {
        margin-top: 20px;
      }
      .content-image {
        display: block;
        width: 100%;
        max-width: 900px;
        height: auto;
      }
      .content-link {
        color: #0000ee;
        text-decoration: underline;
      }
      .content-external-link {
        color: #0000ee;
        text-decoration: underline;
      }
      .download-link {
        display: inline-block;
        margin-top: 12px;
        padding: 18px 30px;
        border-radius: 12px;
        background: #27ae60;
        color: #fff;
        font-size: 36px;
        font-weight: 600;
        line-height: 48px;
        text-decoration: none;
      }
      .component-label {
        color: #d71920;
        font-weight: 700;
      }
    }
  }
}
</style>
